import React from 'react';
import { ContainerTwoThirds } from '../../components/layouts/ContainerTwoThirds';
import { FeatureContainer } from '../../components/molecules/Containers/FeatureContainer';
import { HeaderText } from '../../components/atoms/Texts/HeaderText';
import emojis from '../../theme/emoji';
import useGoToPage from '../../hooks/useGoToPage';
import pages from '../../routes/pages';
import useStyle from './MaClasse.style';
import { FeatureClasseInfos } from '../../components/organisms/Features/FeatureClasseInfos';
import { ContainerFullWidth } from '../../components/layouts/ContainerFullWidth';
import { EspaceProfBlock } from '../../components/molecules/Blocks/EspaceProfBlock';
import { MyClassCategoryButton } from 'components/molecules/Buttons/MyClassCategoryButton';
import ClassObjective from 'components/organisms/ClassObjective';
import { ChangeClassBlock } from 'components/molecules/Blocks/ChangeClassBlock';
import { IS_PROF, MY_ID } from 'helpers/user/authorization';
import { saveLastSeenTab } from 'store/actions/ui.actions';
import { useDispatch } from 'react-redux';
import { NgoBlock } from '../../components/molecules/Blocks/OngBlock';
import { useQuery } from '@apollo/client';
import { GetUserOngQuery } from '../../graphql/generated/graphql';
import { QUERY_USER_ONG } from '../../graphql/query/user/queryUserOng';
import { LoadingContainer } from '../../components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from '../../components/organisms/Error/ErrorContainer';

const MaClasse = () => {
  const { data, loading, error } = useQuery<GetUserOngQuery>(QUERY_USER_ONG, {
    variables: {
      userId: MY_ID
    }
  });
  const dispatch = useDispatch();
  const goToEspaceProf = useGoToPage(pages.ESPACE_PROF.path);
  const goToNgo = useGoToPage(pages.NGO.path);

  const goToControlTab = () => {
    dispatch(saveLastSeenTab(5));
    goToEspaceProf();
  };
  const goToPedagogicalChallenges = useGoToPage(
    pages.PEDAGOGICAL_CHALLENGES.path
  );
  const classes = useStyle();
  if (loading)
    return (
      <LoadingContainer variant={'FeatureClassManager'} status={loading} />
    );
  if (error)
    return (
      <ErrorContainer
        text="Une erreur est survenue, veuillez recharger la page"
        needCaptureError={false}
      />
    );

  return (
    <div className={classes.root}>
      <ContainerTwoThirds
        col1={<FeatureClasseInfos />}
        col2={
          <NgoBlock
            onClick={goToNgo}
            ong={data?.usersPermissionsUser?.data?.attributes?.ong}
          />
        }
      />
      <HeaderText text="Objectif classe" emoji={emojis['Fire']} />
      <ContainerFullWidth>
        <FeatureContainer>
          <ClassObjective />
        </FeatureContainer>
      </ContainerFullWidth>
      <HeaderText text="Liens rapides" emoji={emojis['Link']} />
      {IS_PROF ? (
        <ContainerTwoThirds
          variant="reverse"
          col1={
            <ContainerFullWidth>
              <ChangeClassBlock />
              <EspaceProfBlock variant="MaClasse" onClick={goToEspaceProf} />
              <EspaceProfBlock
                variant="Dashboard"
                content="controlTab"
                onClick={goToControlTab}
              />
            </ContainerFullWidth>
          }
          col2={
            <ContainerFullWidth>
              <MyClassCategoryButton
                title="Défis"
                desc="Relevez les différents défis pour gagner des lots supplémentaires"
                onClick={goToPedagogicalChallenges}
              />
            </ContainerFullWidth>
          }
        />
      ) : (
        <ContainerFullWidth>
          <MyClassCategoryButton
            title="Défis"
            desc="Relevez les différents défis pour gagner des lots supplémentaires"
            onClick={goToPedagogicalChallenges}
          />
        </ContainerFullWidth>
      )}
    </div>
  );
};

export default MaClasse;
